/* CAFFREY Brilliance — page behaviour. Launch build 2026-10-08 (Claude Code, launch agent, WORKFLOW-P builder).
   <cf-br-buy>        colour pills -> the main form's hidden [name=id] (+ a bubbling change event, KIT.md §4a), the live
                      price, the chosen-colour label, Add to cart state, the ?variant= URL, the hero photo of that colour
                      and the colour tiles' state. Nothing is preselected (LAUNCH-BRIEF bulletin 6; colour behaves like
                      size): until a colour is chosen, Add to cart, Shop Pay and the kit sticky bar ask for one
                      ("Choose your colour first.", the pills highlighted and scrolled into view, the first one focused).
                      Shop Pay: Shopify greys its button while the form has no id and a disabled button fires no click,
                      so a transparent guard button covers it until a colour is chosen (Walk On Air pattern,
                      PRE-PUBLISH-FIXES). The kit sticky bar would print "Unavailable": it is patched to read
                      "Choose your colour" with an active Add to cart that presses the main button (which asks).
   [data-cfbr-pick]   the colour tiles further down ("Choose your colour."): a tap picks that colour in place and
                      brings the buy box into view. Without JS they are plain ?variant= links.
   The approved opening animation (cf-br-design) is still driven by assets/cf-br.js (loaded by the layout).
   Safe to load more than once (defer). No dependencies. Never writes the word "undefined" into the page. */
(function () {
  if (window.CfBrPage) return;
  window.CfBrPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function str(v) { return v == null ? '' : String(v); }

  class BrBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.msg = this.querySelector('[data-cfbr-ask]');
      this.box = this.querySelector('[data-cfbr-colours]');
      this.chosenEl = this.querySelector('[data-cfbr-chosen]');
      this.guard = this.querySelector('[data-cfbr-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[type="radio"]'));
      if (!this.radios.length) return; /* single-variant product: the kit form works as it is */

      this.addEventListener('change', function (e) {
        if (e.target && self.radios.indexOf(e.target) > -1) self.select(e.target, true);
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no colour chosen, a
         click anywhere in the payment block asks for a colour instead. */
      var pay = this.querySelector('[data-cfbr-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-cfbr-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      /* the colour tiles further down the page */
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-cfbr-pick]') : null;
        if (!a) return;
        var r = self.radioFor(a.getAttribute('data-cfbr-pick'));
        if (!r) return;
        e.preventDefault();
        if (!r.checked) {
          r.checked = true;
          self.select(r, true);
        }
        self.reveal();
      });
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    radioFor(id) {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].value === str(id)) return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      if (this.chosenEl) this.chosenEl.textContent = '';
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? str(this.dataset.add) : str(this.dataset.soldOut);
      }
      if (this.guard) this.guard.hidden = !any;
      this.tiles(null);
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-cfbr-price]'), function (el) { if (el.textContent !== price) el.textContent = price; });
      if (this.chosenEl) this.chosenEl.textContent = str(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? str(this.dataset.add) : str(this.dataset.soldOut);
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.hero(r);
      this.tiles(r.value);
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* the hero shows the chosen colour's jar (same framing for every colour, so nothing jumps) */
    hero(r) {
      var img = document.querySelector('img[data-cfbr-hero]');
      if (!img) return;
      var phone = r.getAttribute('data-phone'), desk = r.getAttribute('data-desk'), src = r.getAttribute('data-src');
      var source = document.querySelector('source[data-cfbr-hero-src]');
      if (source && phone && source.getAttribute('srcset') !== phone) source.setAttribute('srcset', phone);
      if (desk && img.getAttribute('srcset') !== desk) img.setAttribute('srcset', desk);
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      var alt = r.getAttribute('data-alt');
      if (alt && img.alt !== alt) img.alt = alt;
    }
    tiles(id) {
      each(document.querySelectorAll('[data-cfbr-pick]'), function (a) {
        if (id && a.getAttribute('data-cfbr-pick') === id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    reveal() {
      var t = this.box || this;
      var b = t.getBoundingClientRect();
      if (b.top >= 72 && b.bottom <= window.innerHeight - 96) return;
      t.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
    }
    /* "Choose your colour first.": message under the pills, pills highlighted, scrolled into view, first one focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = str(this.dataset.ask);
        this.msg.hidden = false;
      }
      if (this.box) {
        this.box.classList.remove('is-asking');
        void this.box.offsetWidth; /* restart the highlight when asked again */
        this.box.classList.add('is-asking');
        var b = this.box.getBoundingClientRect();
        if (b.top < 72 || b.bottom > window.innerHeight - 96) {
          this.box.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.box) this.box.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = str(r.getAttribute('data-title'));
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability and price: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      var add = str(this.dataset.add), choose = str(this.dataset.choose);
      if (btn && btn.disabled) btn.disabled = false;
      if (label && add && label.textContent !== add) label.textContent = add;
      if (v && choose && v.textContent !== choose) v.textContent = choose;
    }
  }

  if (!customElements.get('cf-br-buy')) customElements.define('cf-br-buy', BrBuy);
})();
